// extracted by mini-css-extract-plugin
export var container = "R_b";
export var content = "R_b8";
export var icon = "R_bq";
export var iconContainer = "R_dy";
export var icons = "R_bw";
export var image = "R_g";
export var label = "R_cl";
export var section = "R_d";
export var text = "R_b0";
export var title = "R_h";